import React from "react";

const Loader = () => {
  return (
    <div className="lms_page_loader">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
